<form #form="ngForm" novalidate
    class="form-wizard-step"
    [class.first-step]="isFirstStep">
    
    <div class="form-wizard-step-header">
        <h4 class="form-wizard-step-title">
            Cliente
        </h4>
        <p class="form-wizard-step-text">
            Selecione o cliente para qual deseja criar a nova oportunidade.
        </p>
    </div>

    <div class="form-wizard-step-content">
        <div class="row">
            <div class="form-group col-12">
                <label for="cliente" class="col-form-label">Cliente</label>
                <sgt-typeahead-cliente [(ngModel)]="cliente" name="cliente" id="cliente"
                    #clienteTypeaead #clienteModel="ngModel" [ngControl]="clienteModel" required="required"
                    (entitySelected)="onSelected($event)"
                    (clearEntity)="onClear()">
                </sgt-typeahead-cliente>

                <sgt-form-control-error
                    *ngIf="clienteModel.errors && clienteModel.errors.required && clienteModel.dirty"
                    msgError="O cliente é obrigatório">
                </sgt-form-control-error>                      
            </div>
        </div>
    </div>
    
    <div class="form-wizard-step-actions">
        <button type="button" class="btn btn-sm btn-light mr-2" (click)="previus.emit()" *ngIf="!isFirstStep">
            <i class="fas fa-arrow-left"></i> Voltar
        </button>               
        
        <button type="button" class="btn btn-sm btn-primary" (click)="nextClick()" [disabled]="form.invalid">
            Avançar <i class="fas fa-arrow-right"></i>
        </button>
    </div>    
</form>